import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-career-detail',
  templateUrl: './career-detail.component.html',
  styleUrls: ['./career-detail.component.scss']
})
export class CareerDetailComponent {
  jobId!: number;
  job!: any;
  jobs = [
    {
      id: 1,
      title: "Business Development Manager",
      role: "Sales",
      location: {
        country: "India",
        icon: "MapPin"
      },
      buttonText: "Apply Now",
      details: {
        summary: {
          heading: "Job Summary",
          description: "Are you a dynamic, results-driven professional with a passion for building and nurturing client relationships? We are seeking a motivated Business Development Manager to join our growing team. In this role, you will be responsible for identifying new business opportunities, developing strategic partnerships, and driving revenue growth. If you thrive in a fast-paced environment and are eager to make a significant impact, we want to hear from you!"
        },
        responsibilities: {
          heading: "Responsibilities",
          items: [
            "Market Research & Analysis: Conduct market research to identify new business opportunities and emerging trends. Analyze competitor activities and market dynamics to position our offerings effectively.",
            "Lead Generation: Develop and implement strategies to generate leads and acquire new clients. Utilize various channels, including networking events, industry conferences, and digital marketing efforts.",
            "Client Engagement: Build and maintain strong relationships with key clients and stakeholders. Understand their needs and offer tailored solutions to meet their business objectives.",
            "Sales Strategy: Collaborate with the sales and marketing teams to develop and execute strategic plans that drive revenue growth. Set and achieve sales targets and KPIs",
            "Proposal Development: Prepare and present proposals, contracts, and presentations to prospective clients. Negotiate terms and close deals that align with company goals.",
            "Account Management: Manage and oversee key accounts to ensure high levels of customer satisfaction and retention. Address any issues or concerns promptly and effectively.",
            "Reporting: Track and report on business development activities, sales performance, and market trends. Provide regular updates to senior management and recommend adjustments to strategies as needed.",
            "Collaboration: Work closely with cross-functional teams, including product development, marketing, and customer service, to ensure alignment and support business objectives."
          ]
        },
        qualifications: {
          heading: "Qualifications",
          items: [
            "Bachelor’s degree in Business Administration, Marketing, or a related field. Advanced degree or relevant certifications are a plus.",
            "Proven experience in business development, sales, or a similar role, with a track record of meeting or exceeding sales targets.",
            "Strong understanding of market research, lead generation techniques, and sales strategies.",
            "Excellent communication, negotiation, and presentation skills.",
            "Ability to build and maintain relationships with clients and stakeholders at various levels.",
            "Proficient in CRM software and Microsoft Office Suite.",
            "Highly organized with strong project management skills and attention to detail.",
            "Self-motivated with the ability to work independently and as part of a team."
          ]
        },
        offers: {
          heading: "What we offer",
          items: [
            "Competitive salary and performance-based incentives",
            "Comprehensive benefits package, including health insurance and retirement plans",
            "Opportunities for professional development and career growth",
            "A supportive and collaborative work environment"
          ]
        }
      }
    },
    {
      id: 2,
      title: "Infrastructure Engineering Manager",
      role: "Engineering",
      location: {
        country: "India",
        icon: "MapPin"
      },
      buttonText: "Apply Now",
      details: {
        summary: {
          heading: "Job Summary",
          description: "Are you a dynamic, results-driven professional with a passion for building and nurturing client relationships? We are seeking a motivated Business Development Manager to join our growing team. In this role, you will be responsible for identifying new business opportunities, developing strategic partnerships, and driving revenue growth. If you thrive in a fast-paced environment and are eager to make a significant impact, we want to hear from you!"
        },
        responsibilities: {
          heading: "Responsibilities",
          items: [
            "Market Research & Analysis: Conduct market research to identify new business opportunities and emerging trends. Analyze competitor activities and market dynamics to position our offerings effectively.",
            "Lead Generation: Develop and implement strategies to generate leads and acquire new clients. Utilize various channels, including networking events, industry conferences, and digital marketing efforts.",
            "Client Engagement: Build and maintain strong relationships with key clients and stakeholders. Understand their needs and offer tailored solutions to meet their business objectives.",
            "Sales Strategy: Collaborate with the sales and marketing teams to develop and execute strategic plans that drive revenue growth. Set and achieve sales targets and KPIs",
            "Proposal Development: Prepare and present proposals, contracts, and presentations to prospective clients. Negotiate terms and close deals that align with company goals.",
            "Account Management: Manage and oversee key accounts to ensure high levels of customer satisfaction and retention. Address any issues or concerns promptly and effectively.",
            "Reporting: Track and report on business development activities, sales performance, and market trends. Provide regular updates to senior management and recommend adjustments to strategies as needed.",
            "Collaboration: Work closely with cross-functional teams, including product development, marketing, and customer service, to ensure alignment and support business objectives."
          ]
        },
        qualifications: {
          heading: "Qualifications",
          items: [
            "Bachelor’s degree in Business Administration, Marketing, or a related field. Advanced degree or relevant certifications are a plus.",
            "Proven experience in business development, sales, or a similar role, with a track record of meeting or exceeding sales targets.",
            "Strong understanding of market research, lead generation techniques, and sales strategies.",
            "Excellent communication, negotiation, and presentation skills.",
            "Ability to build and maintain relationships with clients and stakeholders at various levels.",
            "Proficient in CRM software and Microsoft Office Suite.",
            "Highly organized with strong project management skills and attention to detail.",
            "Self-motivated with the ability to work independently and as part of a team."
          ]
        },
        offers: {
          heading: "What we offer",
          items: [
            "Competitive salary and performance-based incentives",
            "Comprehensive benefits package, including health insurance and retirement plans",
            "Opportunities for professional development and career growth",
            "A supportive and collaborative work environment"
          ]
        }
      }
    },
  ];

  

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.jobId = params['id']
      this.job = this.jobs.find(job => job.id == this.jobId);
    });
  }

  goBack() {
    this.location.back();
  }
 
  getRoleClass(role: string): string {
    switch (role) {
      case 'Sales':
        return 'role-sale';  
      case 'Engineering':
        return 'role-eng';
        case 'Management':
        return 'role-mngt';
      default:
        return 'role-default';
    }
  }
   
  isModalOpen = false;

  openModal() {
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }
  
  userForm: FormGroup;

  experienceLevels = [
    { value: 'junior', viewValue: 'Junior' },
    { value: 'mid', viewValue: 'Mid-level' },
    { value: 'senior', viewValue: 'Senior' },
    { value: 'lead', viewValue: 'Lead' }
  ];

  constructor(private fb: FormBuilder, private route: ActivatedRoute, private location: Location) {
    this.userForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      experience: ['', Validators.required],
      resume: [null, Validators.required]
    });
  }


  onFileChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.userForm.patchValue({ resume: file });
      this.userForm.get('resume')?.markAsDirty();
      this.userForm.get('resume')?.markAsTouched();
    }
  }
  submitForm() {
    if (this.userForm.invalid) {
      this.userForm.markAllAsTouched(); // This will trigger validation messages on all fields
    } else {
      console.log("Form submission:", this.userForm.value);
      // Form submission logic here
    }
  }

}
